import type {
  CrewRecipientSnapshot,
  Transaction,
} from '@/store/expenses-store/transactions/transactions.dto.ts';

export type CrewRecipient = { id: string; name: string; role: string };

/** The crew member a transaction pays, read from its saved snapshot; null for anyone else. */
export const crewRecipientOf = (
  expense?: Pick<Transaction, 'recipient' | 'detail'> | null,
): CrewRecipient | null => {
  const snapshot = expense?.detail?.recipient as Partial<CrewRecipientSnapshot> | undefined;
  if (snapshot?.type !== 'crew' || !snapshot.name) return null;
  const id = typeof expense?.recipient === 'string' ? expense.recipient : expense?.recipient?.id;
  return { id: id ?? '', name: snapshot.name, role: snapshot.role ?? '' };
};

/** "Nicole Foster · Steward" — how a crew recipient reads in the picker, details and lists. */
export const crewRecipientLabel = ({ name, role }: Pick<CrewRecipient, 'name' | 'role'>) =>
  role ? `${name} · ${role}` : name;

export const toCrewSnapshot = ({ name, role }: CrewRecipient): CrewRecipientSnapshot => ({
  type: 'crew',
  name,
  role,
});
